
export const facilities=[
    "Air Condition",
 "Swimming Pools",
"Sporting Facilities",
"Gym",
"Clubhouse",
"Landscaped Garden",
"Wide-Open Spaces",
"Parks" ,
"Package Lockers",
"Spa"
]

export const documents=[
    "Land Survey Plan ",
"Approved Land Plan",
"Approved Building Documentation",
"Energetic-Certificate-PDF6"
]

export const floorData=[{icon:"bed-icon.svg",name:"4 Beds"},{icon:"bath-icon.svg",name:"4 Baths"},{icon:"building-icon.svg",name:"35000 Sqft"},{icon:"money-icon.svg",name:"$35,000"}]

export const portfolioSlides = [
    "/images/portfolio/Featured.svg",
    "/images/portfolio/Featured1.svg",
    "/images/portfolio/Featured2.svg",
    "/images/portfolio/Featured3.svg",
    "/images/portfolio/Featured4.svg",
    "/images/portfolio/Featured5.svg",
    "/images/portfolio/Featured6.svg",
    "/images/portfolio/Featured7.svg",
    "/images/portfolio/Featured8.svg",
    "/images/portfolio/Featured9.svg",
    "/images/portfolio/Featured10.svg",
    "/images/portfolio/Featured11.svg",
    "/images/portfolio/Featured12.svg",
    "/images/portfolio/Featured13.svg",
    "/images/portfolio/Featured14.svg",
];
